export const AI_AGENT_LIST = {
  data: {
    agents: [
      {
        id: 1,
        backgroundColor: "#E6D5FF",
        slug_t: require("../assets/images/shelly.png"),
       
      },
      {
        id: 2,
        backgroundColor: "#FED1C2",
        slug_t: require("../assets/images/alby.png"),
      
      },
      {
        id: 3,
        backgroundColor: "#D5FEE6",
        slug_t: require("../assets/images/debby.png"),
      
      },
    
    ],
  },
};
export const LOAD_AI_AGENTS = {
  data: {
    agents: [
      {
        id: 1,
        backgroundColor: "#E6D5FF",
        slug: require("../assets/images/shelly.png"),
        name: "Shelly",
        subtitle: "Accounting Agent",
        date: "01 Nov 2024",
        status: "Active",
      },
      {
        id: 2,
        backgroundColor: "#FED1C2",
        slug: require("../assets/images/alby.png"),
        name: "Alby",
        subtitle: "Policy Acceptance Analyst",
        date: "14 Feb 2023",
        status: "Inactive",
      },
      {
        id: 3,
        backgroundColor: "#D7D5FF",
        slug: require("../assets/images/cindy.png"),
        name: "Cindy",
        subtitle: "AI Document Analyst",
        date: "22 Aug 2022",
        status: "Active",
      },
      {
        id: 4,
        backgroundColor: "#FEEBC2",
        slug: require("../assets/images/zina.png"),
        name: "Zina",
        subtitle: "Recruitment Specialist",
        date: "03 Dec 2021",
        status: "Inactive",
      },
      {
        id: 5,
        backgroundColor: "#D5FEE6",
        slug: require("../assets/images/debby.png"),
        name: "Debby",
        subtitle: "Customer Service Agent",
        date: "11 Jan 2024",
        status: "Active",
      },
      {
        id: 6,
        backgroundColor: "#E6D5FF",
        slug: require("../assets/images/raisa.png"),
        name: "Raisa",
        subtitle: "Financial Analyst",
        date: "17 May 2023",
        status: "Active",
      },
    ],
  },
};

export const FORM_KEYS = {
  NAME: "name",
  SYSTEM_AI_AGENT_SLUG: "system_ai_agent_slug",
  ORGANIZATION_ID: "organization",


  INPUT_DIRECTORY_PATH_OR_ADDRESS: "input_directory_path_or_address",
  OUTPUT_DIRECTORY_PATH_OR_ADDRESS: "output_directory_path_or_address",
  PROCESSED_FILE_DIRECTORY_PATH_OR_ADDRESS: "processed_file_directory_path_or_address",
  REJECTED_FILE_DIRECTORY_PATH_OR_ADDRESS: "rejected_file_directory_path_or_address",

  INPUT_DIRECTORY_ID: "input_directory_type",
  INPUT_DIRECTORY_BUCKET_NAME:'input_directory_bucket_name',
  INPUT_DIRECTORY_ACCESS_KEY:'input_directory_access_key',

  OUTPUT_DIRECTORY_ID: "output_directory_type",
  OUTPUT_DIRECTORY_BUCKET_NAME:'output_directory_bucket_name',
  OUTPUT_DIRECTORY_ACCESS_KEY:'output_directory_access_key',

  PROCESSED_FILE_DIRECTORY_TYPE:'processed_file_directory_type',
  PROCESSED_FILE_DIRECTORY_BUCKET_NAME:'processed_file_directory_bucket_name',
  PROCESSED_FILE_DIRECTORY_ACCESS_KEY:'processed_file_directory_access_key',

  REJECTED_FILE__DIRECTORY_TYPE:'rejected_file_directory_type',
  REJECTED_FILE__BUCKET_NAME:'rejected_file_bucket_name',
  REJECTED_FILE__ACCESS_KEY:'rejected_file_access_key',


  OUTPUT_FILE_FORMAT: "output_file_format",
  AGENT_TITLE: "agent_title",
  IS_ACTIVE: "is_active",
  IS_AVAILABLE_TO_ALL_USERS: "is_available_to_all_users",
  OCR_FIELDS:'ocr_fields',
  SYSTEM_INSTRUCTION:'system_instruction',
  OUTPUT_INSTRUCTION:'output_instruction'
};

export const INITIAL_VALUES_STATE={
  [FORM_KEYS.NAME]: "",
  [FORM_KEYS.SYSTEM_AI_AGENT_SLUG]: "example-slug",
  [FORM_KEYS.ORGANIZATION_ID]: 1,

  [FORM_KEYS.INPUT_DIRECTORY_PATH_OR_ADDRESS]: "input_files",
  [FORM_KEYS.OUTPUT_DIRECTORY_PATH_OR_ADDRESS]: "output_files",
  [FORM_KEYS.PROCESSED_FILE_DIRECTORY_PATH_OR_ADDRESS]: "processed_files",
  [FORM_KEYS.REJECTED_FILE_DIRECTORY_PATH_OR_ADDRESS]: "rejected_files",

  [FORM_KEYS.INPUT_DIRECTORY_ID]: "Azure",
  // [FORM_KEYS.INPUT_DIRECTORY_BUCKET_NAME]: "",
  // [FORM_KEYS.INPUT_DIRECTORY_ACCESS_KEY]: "",

  [FORM_KEYS.OUTPUT_DIRECTORY_ID]: "Azure",
  [FORM_KEYS.OUTPUT_DIRECTORY_BUCKET_NAME]: "",
  [FORM_KEYS.OUTPUT_DIRECTORY_ACCESS_KEY]: "",

  [FORM_KEYS.PROCESSED_FILE_DIRECTORY_TYPE]: "Azure",
  [FORM_KEYS.PROCESSED_FILE_DIRECTORY_BUCKET_NAME]: "",
  [FORM_KEYS.PROCESSED_FILE_DIRECTORY_ACCESS_KEY]: "",

  [FORM_KEYS.REJECTED_FILE__DIRECTORY_TYPE]: "Azure",
  [FORM_KEYS.REJECTED_FILE__BUCKET_NAME]: "",
  [FORM_KEYS.REJECTED_FILE__ACCESS_KEY]: "",

  [FORM_KEYS.OUTPUT_FILE_FORMAT]: "JSON",
  [FORM_KEYS.AGENT_TITLE]: "Agent Title",
  [FORM_KEYS.IS_ACTIVE]: true,
  [FORM_KEYS.IS_AVAILABLE_TO_ALL_USERS]: true,
  [FORM_KEYS.OCR_FIELDS]: [],
}



